import { userFlagSpecs } from "shared/featureFlagKeys";
import * as languageMap from "shared/languageMap";

export type UserFlagKey = keyof typeof userFlagSpecs;

interface FeatureFlagInfo {
  key: UserFlagKey;
  description: string;
  availableTo: "god" | "premium" | "free" | "plus";
  experimental: boolean;
  defaultValue?: boolean;
  forumLink?: string;
}

/** User flags in the order in which they'll appear within the Settings page */
export const userFlags: FeatureFlagInfo[] = [
  {
    key: "showTransliterations",
    ...userFlagSpecs.showTransliterations,
    description: `Show transliterations when learning the following languages: ${languageMap.list
      .filter((language) => language.transliterations)
      .map((language) => language.english)
      .join(", ")}.`,
    experimental: false,
    forumLink:
      "https://forum.readlang.com/t/calling-japanese-and-chinese-learners-please-try-new-furigana-and-pinyin-feature-experimental/284",
  },
  {
    key: "askAI",
    ...userFlagSpecs.askAI,
    description:
      "Ask AI for help in Explanation tab and Edit mode of Blitz and Mastery practice modes.",
    experimental: true,
    forumLink:
      "https://forum.readlang.com/t/ask-ai-custom-chatgpt-prompt-feature-for-premium-users-experimental/152",
  },
  {
    key: "contextTranslations",
    ...userFlagSpecs.contextTranslations,
    description:
      "Uses ChatGPT instead of Google Translate to provide context-aware translations. Typically more accurate but slower.",
    experimental: false,
  },
  {
    key: "betterAIModel",
    ...userFlagSpecs.betterAIModel,
    description:
      "Uses the advanced AI model instead of the standard model for all AI powered features: Context Translations, Context Explanations, Review Summaries, and Ask AI. In general this will be slower but more accurate. Eventually, this feature is likely to be part of a more expensive premium plan.",
    experimental: false,
    forumLink:
      "https://forum.readlang.com/t/experimental-option-to-use-full-gpt-4o-model-for-ai-features/690",
  },
  {
    key: "disableMarginButtons",
    ...userFlagSpecs.disableMarginButtons,
    description:
      "Disable the ability to click the page margins to flip pages. With this enabled you will need to instead click the buttons at the bottom of the page instead.",
    experimental: true,
    // forumLink: "",
  },
  {
    key: "explainTitleAndAuthor",
    ...userFlagSpecs.explainTitleAndAuthor,
    description:
      "Designed for people who want to read well-known texts where the language may differ from the commonly spoken language of the day. e.g. Shakespeare, Mark Twain, or Cervantes. By selecting this option, the AI explanations will take the source into account. LIMITATION: These explanations will not show up within the card edit view or within practice, they are only available within the reading interface sidebar.",
    experimental: true,
    // forumLink: "",
  },
];
